import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

export interface EmailTemplate {
	id: string;
	name: string;
	subject: string;
	content?: string;
	description: string;
	placeholders: string[];
	options?: {
		DOCUMENT_LIST?: Array<{
			key: string;
			name: string;
			value: string;
			description?: string;
		}>;
	};
	createdAt: Date;
	updatedAt: Date;
}

export interface DocumentOption {
	id: string;
	label: string;
	value: string;
	description?: string;
}

export interface EmailTemplatePreviewRequest {
	data: {
		customerName?: string;
		selectedDocuments?: string[];
		applicationNumber?: string;
		deadlineDays?: number;
		deadlineDate?: string;
	};
}

export interface EmailTemplatePreviewResponse {
	id: string;
	name: string;
	subject: string;
	content: string;
}

@Injectable({
	providedIn: 'root',
})
export class EmailTemplateService {
	private apiUrl = `${environment.DO_URL}/v1/emails/templates`;

	constructor(private http: HttpClient) {}

	/**
	 * Get all active email templates
	 */
	getEmailTemplates(filters?: {
		id?: string;
		active?: boolean;
		visible?: boolean;
		limit?: number;
	}): Observable<EmailTemplate[]> {
		let params = new HttpParams();

		if (filters?.id) {
			params = params.set('id', filters.id);
		}
		if (filters?.active !== undefined) {
			params = params.set('active', filters.active.toString());
		}
		if (filters?.visible !== undefined) {
			params = params.set('visible', filters.visible.toString());
		}
		if (filters?.limit) {
			params = params.set('limit', filters.limit.toString());
		}

		return this.http.get<EmailTemplate[]>(this.apiUrl, { params });
	}

	/**
	 * Get a specific email template by ID
	 */
	getEmailTemplate(templateId: string): Observable<EmailTemplate> {
		return this.http.get<EmailTemplate>(`${this.apiUrl}/${templateId}`);
	}

	/**
	 * Preview email template with provided data
	 */
	previewEmailTemplate(
		templateId: string,
		request: EmailTemplatePreviewRequest
	): Observable<EmailTemplatePreviewResponse> {
		return this.http.post<EmailTemplatePreviewResponse>(
			`${this.apiUrl}/${templateId}/preview`,
			request
		);
	}
}
